import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { Navigation } from "../../components/Navigation";
import { Lock } from "lucide-react";
import { useNoindex } from "../../hooks/useNoindex";

export const ForgotPasswordPage = () => {
  useNoindex();
  const { requestPasswordReset } = useAuth();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => { document.title = "Password dimenticata | Edicola Cerasuolo"; }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(""); setError("");
    setLoading(true);
    const result = await requestPasswordReset(email.trim().toLowerCase());
    setLoading(false);
    if (result.success) {
      setMessage(result.message || "Se l'email è registrata riceverai un link per reimpostare la password.");
    } else {
      setError(result.error || "Errore. Riprova.");
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0f]">
      <Navigation />
      <div className="max-w-md mx-auto px-4 py-12">
        <div className="bg-[#12121a] border border-gray-800 rounded-2xl p-8">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-500/10 rounded-full mb-4">
              <Lock className="w-8 h-8 text-amber-400" />
            </div>
            <h1 className="text-2xl font-bold text-white mb-2">Password dimenticata?</h1>
            <p className="text-gray-500 text-sm">Inserisci la tua email e ti invieremo un link per reimpostare la password.</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-password-form">
            <div>
              <label className="block text-sm text-gray-400 mb-1">Email</label>
              <input
                type="email"
                required
                data-testid="forgot-email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 bg-[#0a0a0f] border border-gray-700 rounded-lg text-white focus:border-amber-500 focus:outline-none"
                placeholder="email@esempio.it"
              />
            </div>
            {message && (
              <div data-testid="forgot-success" className="bg-green-500/10 border border-green-500/30 text-green-400 text-sm rounded-lg p-3">
                {message}
              </div>
            )}
            {error && (
              <div data-testid="forgot-error" className="bg-red-500/10 border border-red-500/30 text-red-400 text-sm rounded-lg p-3">
                {error}
              </div>
            )}
            <button
              type="submit"
              disabled={loading}
              data-testid="forgot-submit-btn"
              className="w-full py-3 bg-amber-500 hover:bg-amber-400 text-black font-bold rounded-lg transition disabled:opacity-60"
            >
              {loading ? 'Invio in corso...' : 'Invia link di reset'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <a href="/login" className="text-amber-400 hover:text-amber-300 text-sm font-medium">← Torna al login</a>
          </div>
        </div>
      </div>
    </div>
  );
};

